import { __assign, __rest } from "tslib";
import React from 'react';
import InternalCheckbox from './internal';
import { useTelemetry } from '../internal/hooks/use-telemetry';
var Checkbox = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    useTelemetry('Checkbox');
    return React.createElement(InternalCheckbox, __assign({}, props, { ref: ref }));
});
export default Checkbox;
//# sourceMappingURL=index.js.map